import { useTranslation } from 'react-i18next';
import { StatCard } from '@/shared/ui';

import type { TransportStatsData } from '../../model/types';

interface TransportStatsProps {
  stats: TransportStatsData | null;
  isLoading: boolean;
}

export function TransportStats({ stats, isLoading }: TransportStatsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
      <StatCard label={t('welcome.chart.shipments.label')} value={stats?.totalShipments} isLoading={isLoading} />
      <StatCard label={t('welcome.chart.totvolshipped.label')} value={stats?.totalTransported} isLoading={isLoading} />
      <StatCard label={t('welcome.chart.totdests.label')} value={stats?.totalDestinations} isLoading={isLoading} />
      <StatCard
        label={t('welcome.chart.numberoflostordamaged.label')}
        value={
          <div className="flex flex-wrap gap-x-3">
            <span>
              {t('welcome.chart.lost.label')} {stats?.totalLoss}
            </span>
            <span>
              {t('welcome.chart.damaged.label')} {stats?.totalDamage}
            </span>
          </div>
        }
        isLoading={isLoading}
      />
    </div>
  );
}
